import { Fragment } from "react";
import { Grid, MenuItem } from "@mui/material";

import { TextField } from "../../../components";
import Webhook from "./action type components/Webhook";
import UpdateLead from "./action type components/UserUpdate";
import { SendMessageAction } from "./action type components/SendMessageAction";

export default function FormDisplay({
  fields,
  setTemp,
  actionType,
  editState,
  formikProps,
  parentFormik,
}) {
  return (
    <Fragment>
      <Grid item xs={3}>
        <TextField
          name="actionName"
          label="Action Name"
          formikProps={formikProps}
          disabled={!editState}
        />
      </Grid>

      <Grid item xs={3}>
        <TextField
          select
          name="actionType"
          label="Action Type"
          formikProps={formikProps}
          disabled={!editState}
        >
          {actionType.map((act) => (
            <MenuItem key={act._id} value={act._id}>
              {act.action_type}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      {formikProps.values?.actionType === "675125cd1b23fa51e9fab559" && (
        <UpdateLead
          fields={fields}
          editState={editState}
          formikProps={formikProps}
        />
      )}

      {formikProps.values?.actionType === "675125a61b23fa51e9fab558" && (
        <SendMessageAction
          fields={fields}
          setTemp={setTemp}
          formikProps={formikProps}
          editState={editState}
        />
      )}

      {formikProps.values?.actionType === "6763f8fe93c8acee5f29dd71" && (
        <Webhook
          fields={fields}
          formikProps={formikProps}
          editState={editState}
        />
      )}
    </Fragment>
  );
}
